import { css } from 'aphrodite';
import { saveAs } from 'file-saver';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { toast } from 'sonner';
import { IUserSessionComponentProps, UserSessionViewModelKey } from '../../../../models/AppState';
import { FilesDropTarget } from '../../../../web/components/FilesDropTarget';
import { ISelectBoxOption, SelectBox } from '../../../../web/components/SelectBox';
import { SpreadsheetIcon } from '../../../../web/components/svgs/icons/SpreadsheetIcon';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps extends IUserSessionComponentProps {
	className?: string;
	isOpen?: boolean;
}

interface IState {
	amsDataType?: AmsDataType;
	csvFiles?: File[];
	showLoader?: boolean;
}

type AmsDataType = 'AMS360';

const AMSDataSourceOptions: ISelectBoxOption<AmsDataType>[] = [
	{
		title: 'AMS360',
		value: 'AMS360',
	},
];

class _ConvertToLevitate extends React.Component<IProps> {
	public state: IState = {
		amsDataType: 'AMS360',

		csvFiles: null,
		showLoader: false,
	};

	private chooseDifferentFileClick = () => {
		this.setState({ csvFiles: null });
	};

	private convertClick = () => {
		if (this.state.csvFiles) {
			const data = new FormData();
			data.append('value', JSON.stringify({ type: this.state.amsDataType }));

			this.state.csvFiles.forEach(csvFile => {
				data.append('files', csvFile);
			});

			this.props.userSession.webServiceHelper.callWebServiceRawResponse(
				'admin/importOperations/convertFromFileType',
				'POST',
				data, // Passing FormData here since it's a file upload
				this.importSuccess,

				result => this.importError(result.systemMessage)
			);

			this.setState({ showLoader: true });
		} else {
			toast.error('You must select a file to import');
		}
	};

	public render() {
		const { className } = this.props;
		return (
			<div className={`${css(styleSheet.container)} convert-to-levitate ${className || ''}`}>
				<div className={css(styleSheet.header)}>Convert from AMS file(s) to Levitate CSV</div>
				<div className={css(styleSheet.row)}>
					<div className={css(styleSheet.rowLabel)}>Select AMS Source:</div>
					<SelectBox
						className={css(styleSheet.rowValue)}
						onSelectionChanged={this.onAMSDataSourceTypeChanged}
						options={AMSDataSourceOptions}
						selectedOption={AMSDataSourceOptions[0]}
					/>
				</div>

				{!this.state.csvFiles && (
					<div>
						<div className={css(styleSheet.dragInstructions, styleSheet.warning)}>
							{this.state.amsDataType === 'AMS360' && <>AMS360 requires a single .csv file.</>}
						</div>
						<div className={css(styleSheet.dragInstructions)}>Drag data files into the box below.</div>
						<div className={css(styleSheet.upload)}>
							<FilesDropTarget
								className={css(styleSheet.uploadTarget)}
								supportMultiple={true}
								supportedFileExtensions={['csv']}
								onFilesDropped={this.onFileDropped}
							>
								<SpreadsheetIcon />
							</FilesDropTarget>
						</div>
					</div>
				)}
				{!!this.state.csvFiles && (
					<div>
						<div className={css(styleSheet.upload)}>
							<SpreadsheetIcon className={css(styleSheet.uploadTarget)} />
						</div>
						<div>{this.state.csvFiles ? this.state.csvFiles[0].name : ''}</div>
						<span onClick={this.chooseDifferentFileClick} className={css(baseStyleSheet.brandSecondaryLink)}>
							Choose a different file
						</span>
						<div className={css(styleSheet.row)}>
							<button className={css(baseStyleSheet.ctaButtonSmall)} onClick={this.convertClick}>
								Convert Contacts
							</button>
						</div>
					</div>
				)}
			</div>
		);
	}

	private onAMSDataSourceTypeChanged = (option: ISelectBoxOption<AmsDataType>) => {
		if (!!option && !!option.value) {
			this.setState({
				amsDataType: option.value,
			});
		}
	};

	private onFileDropped = (files: File[]) => {
		if (files.length > 0) {
			this.setState({ csvFiles: files });
		}
	};

	private importSuccess = async (response: Response) => {
		this.setState({
			csvFiles: null,
			showLoader: false,
		});
		const blob = await response.blob();
		saveAs(blob, 'levitate-contacts.csv', true);
	};

	private importError = (errorMessage: string) => {
		toast.error(errorMessage);

		this.setState({ showLoader: false });
	};
}

const ObservableContactToLevitate = observer(_ConvertToLevitate);
export const ConvertToLevitate = inject(UserSessionViewModelKey)(ObservableContactToLevitate);
